import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9b689c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-5 align-items-center mb-2" }
const _hoisted_2 = { class: "table table-row-dashed" }
const _hoisted_3 = { class: "text-muted fw-bold text-uppercase" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "comment" }
const _hoisted_8 = { class: "comment" }
const _hoisted_9 = { class: "dialog-footer" }

import { ref } from "vue";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import {
  creditAdjustTypes,
  adjustRecordStatusOptions,
  AdjustRecordStatusTypes,
} from "@/core/types/CreditAdjustTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BatchDetail',
  setup(__props, { expose: __expose }) {

const modalRef = ref(false);
const isLoading = ref(false);
const BatchId = ref(0);
const totalData = ref<any>({});
const status = ref(false);
const data = ref<any>({});
const criteria = ref({
  adjustBatchId: BatchId.value,
  size: 10,
  page: 1,
  statuses: [],
});
const show = (item: any) => {
  modalRef.value = true;
  totalData.value = item;
  BatchId.value = item.id;
  if (item.status === AdjustRecordStatusTypes.Created) {
    status.value = true;
  } else {
    status.value = false;
  }
  criteria.value.adjustBatchId = BatchId.value;
  fetchData(1);
};
watch(
  () => criteria.value.statuses,
  (value) => {
    criteria.value.statuses = value;
    fetchData(1);
  }
);
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  const tempStatus = criteria.value.statuses;
  try {
    const response = await PaymentService.getBatchDetail(criteria.value);
    data.value = response.data;
    criteria.value = response.criteria;
    criteria.value.statuses = tempStatus;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};
const getType = (status: number) => {
  if (
    status === AdjustRecordStatusTypes.Completed ||
    status === AdjustRecordStatusTypes.Deleted
  ) {
    return "success";
  } else if (status === AdjustRecordStatusTypes.Failed) {
    return "danger";
  } else if (status === AdjustRecordStatusTypes.Processing) {
    return "warning";
  } else {
    return "primary";
  }
};
const confirmBatch = async () => {
  try {
    const response = await PaymentService.confirmBatch(BatchId.value);
    MsgPrompt.success(response.message);
    modalRef.value = false;
  } catch (error) {
    MsgPrompt.error(error);
  }
};
__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: modalRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalRef).value = $event)),
    width: "800",
    "align-center": "",
    class: "rounded"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tag, { type: "info" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.totalAccounts")) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(totalData.value.result.TotalAccounts), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.accountsInSystem")) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(totalData.value.result.AccountsInOurSystem), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, { type: "success" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.totalSuccess")) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(totalData.value.result.SuccessCount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, { type: "danger" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.totalFailed")) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(totalData.value.result.FailedRecords?.length), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, { type: "warning" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("title.totalAmount")) + ": ", 1),
            _createVNode(_component_BalanceShow, {
              balance: totalData.value.result.TotalAmount
            }, null, 8, ["balance"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: criteria.value.statuses,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.statuses) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adjustRecordStatusOptions), (item) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                key: item.value,
                label: item.value,
                name: item.label
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (modalRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        }),
        (status.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmBatch()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.confirmToProcess")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.note")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(creditAdjustTypes)[item.type]), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_tag, {
                        size: "small",
                        type: getType(item.status)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`status.${_unref(AdjustRecordStatusTypes)[item.status]}`)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.amount / 100), 1),
                    _createElementVNode("td", _hoisted_7, [
                      _createVNode(_component_el_popover, {
                        width: "300",
                        content: item.comment,
                        placement: "top"
                      }, {
                        reference: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.comment), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "oneLiner",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})